<template>
	<dialog
		ref="dialogRef"
		class="max-w-[400px] w-full rounded-lg border-2 border-gray-300 backdrop:backdrop-blur-[2px]"
	>
		<header class="p-4 border-b border-gray-200 text-gray-700 font-bold text-lg">
			{{ content.heading }}
		</header>
		<p
			class="p-4 text-gray-500 text-sm break-words text-justify border-b border-gray-200"
		>
			{{ content.body }}
		</p>
		<footer class="flex gap-2 items-center p-4 justify-end">
			<Button
				v-if="content.cancelButton"
				@click="handleReject"
				:variation="content.cancelButtonVariation"
				type="button"
				>{{ content.cancelButton }}</Button
			>
			<Button
				v-if="content.ctaButton"
				@click="handleResolve"
				:variation="content.ctaButtonVariation"
				type="button"
				>{{ content.ctaButton }}</Button
			>
		</footer>
	</dialog>
</template>

<script setup>
const dialogRef = ref(null)

const INITIAL_CONTENT = {
	heading: '',
	body: '',
	ctaButton: '',
	ctaButtonVariation: 'destructive',
	cancelButton: 'Zavrieť',
	cancelButtonVariation: 'secondary'
}

let resolve, reject

const content = ref(structuredClone(INITIAL_CONTENT))

const open = () => {
	dialogRef.value.showModal()
}

const close = () => {
	dialogRef.value.close()

	content.value = structuredClone(INITIAL_CONTENT)
}

const present = (payload) => {
	content.value = { ...content.value, ...payload }

	open()

	return new Promise((res, rej) => {
		resolve = res
		reject = rej
	})
}

const handleResolve = async () => {
	await closeAnimation()

	close()

	resolve()
}

const closeAnimation = () =>
	new Promise((resolve) => {
		{
			const animation = dialogRef.value.animate(
				{ translate: '0 15%', scale: 0.9 },
				{ duration: 100 }
			)

			animation.onfinish = () => {
				resolve()
			}
		}
	})

const handleReject = async () => {
	await closeAnimation()

	close()

	reject()
}
defineExpose({ present })
</script>

<style scoped>
dialog {
	animation: slide-in 150ms ease-in-out;
}

@keyframes slide-in {
	0% {
		translate: 0 15%;
		scale: 0.9;
	}

	100% {
		translate: 0;
		scale: 1;
	}
}
</style>
